/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    cov: {
        id: 'quoteandbind.PLSRLinedirectives.templates.Information.Coverages',
        defaultMessage: 'Coverages'
    },
    
});